module.exports = __webpack_public_path__ + "static/media/why_nb.62e83cc8.vtt";